import { creatorbase } from '@round/api';
import { useCallback } from 'react';
import { useInvalidateAggregatedPostStats } from '@round/creatorbase-helpers/api-hooks';
import useInvalidateProjectCampaignContext from './useInvalidateProjectCampaignContext';
import useProjectId from './useProjectId';

// Invalidate the campaign- and project-level stats a post mutation can affect:
// the aggregated post stats for the campaign and the wider project campaign
// context. Mirrors the cascade the legacy PostsContext ran after every write so
// the new per-mutation hooks keep stats in sync without going through it.
export default function useRefreshProjectCampaignStats() {
    const projectId = useProjectId();
    const invalidateProjectCampaignContext = useInvalidateProjectCampaignContext();
    const invalidateAggregatedPostStats = useInvalidateAggregatedPostStats();

    return useCallback(
        (campaignId: number, platform: creatorbase.Platform) =>
            Promise.all([
                typeof projectId === 'number'
                    ? invalidateProjectCampaignContext({ project_id: projectId, platform })
                    : Promise.resolve(),
                invalidateAggregatedPostStats({ campaign_id: campaignId }),
            ]),
        [invalidateProjectCampaignContext, invalidateAggregatedPostStats, projectId]
    );
}
